//no-unused-vars
import React, {Component} from 'react';
import {ApplicationFormFile} from './2021ApplicationHyperComplex.doc'
import AbstractFormat from "./HyperComplexSem_2021-08-26.zip";
import ApplicationFormPDF from "./Conference_Announcement.pdf";
import ApplicationFormODT from "./Application_form2.odt";
import AddAbstractDeadlineToUserCallendar from './MyCallendar';
 
export const SubmitAbstractPage = () => (
  <div>
	<div class="row">		
		&nbsp;
	</div>
	<div class="row">
		<div class="col-md-1">								
		</div>
		<div class="col-md-9">								
	<h2>Abstract Submissions</h2>
	<p>All submissions will be reviewed by our prestigious international review committee with a preference towards (Hyper)Complex Analysis in Differential Equations Geometry and Physical Applications including also applications-focused work with physics, electronics, mechanics and materials science relevance.</p>
		</div>
		<div class="col-md-2">&nbsp;								
		</div>
	</div>
	<div className='container-fluid'>
		<div class="row">
			<div class="col-md-1">								
			</div>
			
			<div class="col-md-4">
				<h3>To Submit an Abstract:</h3>
				<ul>
					<li>Complete the Application and send in form (<a href={ApplicationFormODT}>ODT file</a>) before 1<sup>st</sup>  July, 2023 (-)</li>
					<li>Download the LaTeX style file to prepare your abstract and send both tex and pdf file to <a href="mailto:HyperComplexSeminar@gmail.com">HyperComplexSeminar@gmail.com</a> with "Abstract submission" subject</li>
					<li>The style file for <a href={AbstractFormat} >the abstract is here</a>, for the article is here.</li>
				</ul>				
			</div>
			
			<div class="col-md-1">								
			</div>
			
			<div class="col-md-4">
				<h3>Important Dates for both stationary and online participants:</h3>
				<ul>
					<li>Author Registration Deadline: 1<sup>st</sup>  July, 2023 – no exceptions to this date will be granted ( - )</li>
					<li>Abstracts submission  for talks and poster session: 1<sup>st</sup>  July, 2023 ( - )</li>
					<li>Papers ready for publication submission: 11<sup>st</sup>  November, 2023</li>					
					<p>Accepted authors must register for the conference.</p>					
				</ul>				
			</div>
			
			<div class="col-md-1">								
			</div>
		</div>
	</div>	
	<div className='container-fluid'>
		<div class="row">
			<div class="col-md-1">								
			</div>
			
			<div class="col-md-4">
				<h3>Conference fee:</h3>
				<ul>
					<li>Online participation is free of charge.</li>
//					<li>Live in Bendlewo 1950 PLN.</li>
				</ul>				
			</div>
			
			<div class="col-md-1">								
			</div>
			
			<div class="col-md-4">
			</div>
			
			<div class="col-md-1">								
			</div>
		</div>
	</div>			
  </div>
);
 
//export default SubmitAbstractPage
